<div class="layout-topbar mb-0">
    <div class="topbar-start">
        <!-- <button #menubutton type="button" class="topbar-menubutton p-link p-trigger" (click)="onMenuButtonClick()">
            <i class="pi pi-bars"></i>
        </button>
        <a class="cursor-pointer" href="#">
            <img class="w-8rem"animateEnter="moveinright" src="assets/its/images/logo_italset.svg" alt="italset" title="italset">
        </a> -->
    </div>

    <div class="topbar-end">
        <ul class="topbar-menu">
            <!-- <li class="topbar-search">
                <span class="p-input-icon-left">
                    <i class="pi pi-search"></i>
                    <input type="text" pInputText placeholder="Search" class="w-12rem sm:w-full">
                </span>
            </li> -->
            <li class="topbar-profile">
                <span class="block cursor-pointer text-sm text-center font-medium" [routerLink]="['/privacy-policy']">Informativa Privacy</span>
            </li>                       
            <li class="topbar-profile">
                <span class="block cursor-pointer text-sm text-center font-medium" [routerLink]="['/cookie-policy']">Termini e Condizioni</span>                
            </li>
        </ul>
    </div>
</div>
<p-divider styleClass="my-1"></p-divider>
<div class="flex flex-column align-items-center align-content-start mx-auto md:mx-0">
    <div class="text-900 text-sm font-medium">Italset S.r.l.<span class="text-600 font-normal text-xs">&nbsp;&nbsp;Sede legale: Via Giuseppe Sansonetti, 20 - 73042 Casarano (LE)</span></div>
    <div class="text-600 text-xs">CF e P.IVA 03890260759 - Iscrizione Registro Imprese di LECCE R.E.A. LE-252591 </div>
</div>